import React, { useCallback } from 'react';

import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Skeleton from '@mui/material/Skeleton';

import { CoreSubject } from '@ts-core/modules/subjects/types';

import SubjectTreeItemIcon from './SubjectTreeItemIcon';

interface SubjectTreeItemProps {
  children?: React.ReactNode;
  subject?: CoreSubject;
  loading?: boolean;
  fetchingSubjectContent?: boolean;

  isSubjectOpen: (subject: CoreSubject) => boolean;
  onClickSubject: (subject: CoreSubject) => void;
}

const SubjectTreeItem = (props: SubjectTreeItemProps) => {
  const { subject, children, fetchingSubjectContent = false, loading = false, isSubjectOpen, onClickSubject } = props;

  const handleClick = useCallback(() => {
    if (subject) {
      onClickSubject(subject);
    }
  }, [subject, onClickSubject]);

  return (
    <Box>
      <ListItem button onClick={handleClick} disabled={loading}>
        <Box mr={1}>
          <SubjectTreeItemIcon open={!!subject && isSubjectOpen(subject)} loading={fetchingSubjectContent} />
        </Box>
        <ListItemText primary={loading ? <Skeleton width={180} /> : subject?.name} />
      </ListItem>
      {subject ? children : <span />}
    </Box>
  );
};

export default SubjectTreeItem;
